// extracted by mini-css-extract-plugin
export default {"notfound":"not-found_notfound__ykVjn","notfound__img":"not-found_notfound__img__S4p6z"};